var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { timeoutPromise } from 'bernie-core';
import { getErrorString } from 'bernie-logger';
import { action, computed, observable, runInAction } from 'mobx';
import { getMessageId, getTraceId, getTrackingInfoForLoggingFromHeaders } from '../common/logging-utils';
import { getDateRange, getRegionDetails, getStickyBarLeadPrice, trackInventoryErrorEvent } from '../helpers/activity-detail-helper';
import { LXStore } from './lx-store';
import { STORE_EVENTS } from './store-events';
var ActivityDetailStore = /** @class */function (_super) {
  __extends(ActivityDetailStore, _super);
  function ActivityDetailStore(bexApiSource, state, bexConfigs, logger, appConfig, requestOrContext) {
    if (state === void 0) {
      state = {};
    }
    if (appConfig === void 0) {
      appConfig = {};
    }
    var _this = _super.call(this, bexApiSource, state, bexConfigs, logger, appConfig, requestOrContext) || this;
    _this.activityAvailability = [];
    _this.activityDetail = null;
    _this.activityPreloadedData = null;
    _this.availabilityCalendar = [];
    _this.isOfferDialogOpen = false;
    _this.isOffersLoading = true;
    _this.showInclusions = true;
    _this.photoGalleryIndex = 0;
    _this.offerInclusionFilter = null;
    _this.query = {};
    _this.analyticsStore = null;
    _this.experimentStore = null;
    _this.offerMealInclusions = [];
    _this.offerFiltersMap = null;
    return _this;
  }
  ActivityDetailStore.prototype.hydrate = function (data) {
    if (data) {
      delete data.bexApiSource;
      Object.assign(this, data);
    }
  };
  ActivityDetailStore.prototype.resetActivityOffers = function () {
    this.isOffersLoading = true;
  };
  ActivityDetailStore.prototype.resetDetailsPage = function (preloadedActivity) {
    this.activityDetail = null;
    this.resetActivityOffers();
    if (preloadedActivity) {
      this.activityPreloadedData = {
        activity: preloadedActivity
      };
    }
  };
  ActivityDetailStore.prototype.fetchActivityDetail = function (detailVariables, detailCriteriaStore, pageIdentity, query) {
    var _this = this;
    var _a;
    this.isDetailFetchError = false;
    return timeoutPromise(this.bexApiSource.activityDetailBasic(detailVariables, pageIdentity, getTraceId(this.headers), getMessageId(this.headers)), (_a = this.appConfig.timeout) === null || _a === void 0 ? void 0 : _a.serverStoreFetch, "store=detail fetch=fetchActivityDetail timeout ".concat(getTrackingInfoForLoggingFromHeaders(this.headers))).then(function (response) {
      runInAction('update bex api activity detail from response', function () {
        if (response.data) {
          _this.activityDetail = response.data.activityInfo;
          if (response.data.activityInfo.offers) {
            var leadPrice = void 0;
            _this.isOffersLoading = false;
            if (_this.activityDetail) {
              _this.activityDetail.offersSummary.filters = response.data.activityInfo.offersSummary.filters;
              leadPrice = getStickyBarLeadPrice(_this.activityDetail.offersSummary.leadTicketView);
            }
            if (_this.isPageLoading && leadPrice && _this.analyticsStore) {
              _this.isPageLoading = false;
            }
          }
          _this.processFetchNewDetailsResponse(response, detailCriteriaStore, query);
        } else {
          _this.detiailFetchFailure(detailVariables);
        }
      });
    }).catch(function (error) {
      runInAction('recovering from bex api activity detail call breakdown', function () {
        _this.detiailFetchFailure(detailVariables, error);
      });
    });
  };
  ActivityDetailStore.prototype.fetchActivityOffersWithAvailability = function (detailVariables, detailCriteriaStore, pageIdentity, query) {
    var _this = this;
    this.isDetailFetchError = false;
    return this.bexApiSource.activityDetailOffersWithAvailability(detailVariables, pageIdentity, getTraceId(this.headers), getMessageId(this.headers)).then(function (response) {
      runInAction('update bex api activity detail offers with availability from response', function () {
        if (_this.activityDetail) {
          _this.isOffersLoading = false;
          _this.activityDetail.presentation.banners = response.data.activityInfo.presentation.banners;
          _this.activityDetail.presentation.promotionMessage = response.data.activityInfo.presentation.promotionMessage;
          _this.activityDetail.offersSummary = response.data.activityInfo.offersSummary;
          _this.processFetchNewDetailsResponse(response, detailCriteriaStore, query);
          if (_this.experimentStore && _this.analyticsStore) {
            trackInventoryErrorEvent(_this.experimentStore, _this.activityDetail.presentation.banners, _this.analyticsStore);
          }
        }
      });
    }).catch(function (error) {
      runInAction('recovering from bex api activity detail availability call breakdown', function () {
        _this.failureHandler(detailVariables, STORE_EVENTS.DETAIL_AVAILABILITY_FETCH_FAILED, error);
        _this.isOffersLoading = false;
      });
    });
  };
  ActivityDetailStore.prototype.failureHandler = function (variable, event, error) {
    this.logger.logEvent(event, variable, error ? getErrorString(error) : null);
  };
  ActivityDetailStore.prototype.populateFirstOfferAvailableDate = function (detailCriteriaStore) {
    if (this.activityAvailability && this.activityAvailability.length > 0) {
      var filtered = this.activityAvailability.filter(function (t) {
        return t.isAvailable;
      });
      detailCriteriaStore.selectedDate = filtered.length > 0 ? filtered[0].date : null;
    }
  };
  ActivityDetailStore.prototype.isOfferAvailabilityPresent = function () {
    if (this.activityAvailability && this.activityAvailability.length > 0) {
      var filtered = this.activityAvailability.filter(function (t) {
        return t.isAvailable;
      });
      return filtered.length > 0;
    }
    return false;
  };
  ActivityDetailStore.prototype.setAnalyticsStore = function (analyticsStore) {
    this.analyticsStore = analyticsStore;
  };
  ActivityDetailStore.prototype.setExperimentStore = function (experimentStore) {
    this.experimentStore = experimentStore;
  };
  ActivityDetailStore.prototype.getExperimentStore = function () {
    return this.experimentStore;
  };
  ActivityDetailStore.prototype.setPageLoading = function (isPageLoading) {
    this.isPageLoading = isPageLoading;
  };
  ActivityDetailStore.prototype.getOfferFiltersMap = function () {
    return this.offerFiltersMap;
  };
  ActivityDetailStore.prototype.setOfferFiltersMap = function (offerFiltersMap) {
    this.offerFiltersMap = offerFiltersMap;
  };
  ActivityDetailStore.prototype.getOfferMealInclusions = function () {
    return this.offerMealInclusions;
  };
  ActivityDetailStore.prototype.setOfferMealInclusions = function (offerMealInclusions) {
    this.offerMealInclusions = offerMealInclusions;
  };
  ActivityDetailStore.prototype.setOfferFilters = function (filters) {
    if (this.activityDetail) {
      this.activityDetail.offersSummary.filters = filters;
    }
  };
  Object.defineProperty(ActivityDetailStore.prototype, "datePickerContent", {
    get: function () {
      return this.availabilityCalendar ? this.availabilityCalendar.reduce(function (content, availability) {
        content[availability.date.isoFormat] = availability.price && availability.price.formatted;
        return content;
      }, {}) : null;
    },
    enumerable: false,
    configurable: true
  });
  ActivityDetailStore.prototype.processFetchNewDetailsResponse = function (response, detailCriteriaStore, query) {
    this.activityAvailability = response.data.activityInfo && response.data.activityInfo.availabilities;
    this.availabilityCalendar = response.data.activityInfo.availabilityCalendar;
    this.uisPayload = response.extensions.analytics;
    this.updateDetailCriteria(detailCriteriaStore, query);
    this.populateFirstOfferAvailableDate(detailCriteriaStore);
    detailCriteriaStore.setQueryStringUpdated(false);
    this.activityPreloadedData = null;
  };
  ActivityDetailStore.prototype.updateDetailCriteria = function (detailCriteriaStore, query) {
    var regionDetails = getRegionDetails(this, query);
    var newParams = {};
    if (regionDetails) {
      newParams = __assign(__assign({}, newParams), {
        location: regionDetails.location,
        rid: regionDetails.rid
      });
    }
    var availabilities = this.activityAvailability;
    var dateRange = getDateRange(availabilities);
    if (dateRange) {
      newParams = __assign(__assign({}, newParams), {
        startDate: dateRange.startDate,
        endDate: dateRange.endDate
      });
    }
    detailCriteriaStore.detailQuery = __assign(__assign({}, detailCriteriaStore.detailQuery), newParams);
  };
  ActivityDetailStore.prototype.detiailFetchFailure = function (detailVariables, error) {
    this.isDetailFetchError = true;
    this.failureHandler(detailVariables, STORE_EVENTS.DETAIL_BASIC_FETCH_FAILED, error);
  };
  __decorate([observable], ActivityDetailStore.prototype, "activityAvailability", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "activityDetail", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "activityPreloadedData", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "availabilityCalendar", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "isDetailFetchError", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "isOfferDialogOpen", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "isOffersLoading", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "showInclusions", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "uisPayload", void 0);
  __decorate([observable], ActivityDetailStore.prototype, "photoGalleryIndex", void 0);
  __decorate([action], ActivityDetailStore.prototype, "fetchActivityDetail", null);
  __decorate([action], ActivityDetailStore.prototype, "fetchActivityOffersWithAvailability", null);
  __decorate([computed], ActivityDetailStore.prototype, "datePickerContent", null);
  return ActivityDetailStore;
}(LXStore);
export { ActivityDetailStore };